import { TopicId } from '~/dashboard/utils/learningPath.utils'

import { CurriculumTopicDataType } from '../types/curriculum.types'

export enum CurriculumGradeLevelType {
  BOOTCAMP = 'bootcamp',
  AI = 'ai-prompt',
  ENCYCLOPEDIA = 'encyclopedia',
  MATH_VAULT = 'math-vault',
}

export enum CurriculumCountryCodes {
  PHILIPPINES = 'ph',
  USA = 'us',
  NORWAY = 'no',
  UKRAINIAN = 'ua',
  FLORIDA = 'fl',
  DEFAULT = 'default',
}

/**
 * Exact `country` values returned by GET /v1/curriculum/countries.
 *
 * These are identifiers, not display copy: `handleOptionSelect` sends the chosen name straight back
 * to the API, which validates it against this same list, so they must match verbatim and must not be
 * translated. Note USA and CALIFORNIA_CCSSM share the country code 'us' — they are told apart by the
 * persisted curriculum name in the persistCurriculum slice.
 */
export enum CurriculumCountryNames {
  USA = 'USA',
  CALIFORNIA_CCSSM = 'California CCSSM',
  FLORIDA = 'Florida',
  NORWAY = 'Norge',
  UKRAINIAN = 'Українська',
  PHILIPPINES = 'Philippines',
  DEFAULT = 'International',
}

export enum CurriculumSelectionPoints {
  SELECT_GRADE,
  FOOTER,
  HAMBURGER_MENU,
  CAMPAIGN_PAGE,
}

export const curriculumSubjectContentDefault = {
  topicId: TopicId.ALGEBRA,
  subjectLabel: '',
  subjectOrder: 0,
  subjectOrderLabel: '',
  subjectUrl: '',
  competencyGoals: [],
} as CurriculumTopicDataType

export enum LevelSource {
  PRE_REQUISITE = 'pre-requisite',
  CURRICULUM = 'curriculum',
}

// Query param marking that the user reached the select-grade page via a dashboard button ("Select Grade" or
// "change curriculum"), so a grade click auto-saves immediately, regardless of whether a grade is already
// selected (same rule as onboarding). Browsing to select-grade any other way does not set this param.
export const SELECT_GRADE_ORIGIN_PARAM = 'origin'
export const DASHBOARD_SELECT_GRADE_ORIGIN = 'dashboard-select-grade'

// The activity's own answer field; the Oracle input in the same modal is a math-field too
export const ACTIVITY_MATH_FIELD_SELECTOR = '[data-fullscreen-activity] math-field:not([data-oracle-input])'
